// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconWifi = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
    stroke,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 16,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-wifi">
      <svg
        className="c-icon-wifi fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.695 14.4625C11.695 14.8235 11.3903 15.0998 11.0577 15.0998C10.7222 15.0998 10.4459 14.7951 10.4459 14.4881C10.4459 9.71474 6.56112 5.80463 1.76246 5.80463C1.40287 5.80463 1.12512 5.52688 1.12512 5.16729C1.12512 4.80631 1.42983 4.52996 1.76246 4.52996C7.22923 4.52996 11.695 8.97004 11.695 14.4625Z" fill={fill || ''} stroke={stroke || ''} strokeWidth="0.1" />
        <path d="M7.7624 14.4626C7.7624 14.8235 7.4577 15.0999 7.12507 15.0999C6.78958 15.0999 6.51327 14.7952 6.51327 14.4881C6.51327 11.8599 4.36506 9.71173 1.7369 9.71173C1.37731 9.71173 1.09956 9.43398 1.09956 9.0744C1.09956 8.71341 1.40427 8.43706 1.7369 8.43706C5.0587 8.43706 7.7624 11.1408 7.7624 14.4626Z" fill={fill || ''} stroke={stroke || ''} strokeWidth="0.1" />
        <path d="M1.76301 1.8465H1.76283C1.40324 1.8465 1.12549 1.56875 1.12549 1.20916C1.12549 0.848179 1.43019 0.571826 1.76283 0.571826C9.4258 0.571826 15.6535 6.79954 15.6535 14.4625C15.6535 14.8235 15.3488 15.0999 15.0162 15.0999C14.6821 15.0999 14.3788 14.7966 14.3788 14.4625C14.3788 7.49307 8.70657 1.82106 1.76301 1.8465Z" fill={fill || ''} stroke={stroke || ''} strokeWidth="0.1" />
        <path d="M2.33461 15.3772C3.17841 15.3772 3.84961 14.6868 3.84961 13.8622C3.84961 13.0375 3.15923 12.3472 2.33461 12.3472C1.50999 12.3472 0.81961 13.0375 0.81961 13.8622C0.81961 14.6868 1.49081 15.3772 2.33461 15.3772Z" fill={fill || ''} />
      </svg>
    </Icon>
  );
};

export default IconWifi;
